/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import courseApi from '../api/course';
import RoutesGenerator, { Route } from '../services/router/generator';

type RestrictionResponse = any;

interface UseCourseRestrictionResult {
  data: RestrictionResponse;
  locked: boolean;
  loading: boolean;
  error: Error | null;
}

/**
 * useCourseRestriction
 * Fetch course restriction info for a course id.
 *
 * @param courseId optional initial id to fetch
 * @param options.autoFetch whether to auto-fetch on mount
 */
const useCourseRestriction = (
  courseId: number,
  returnUrlOnSubmit: string,
): UseCourseRestrictionResult => {
  const [data, setData] = useState<RestrictionResponse>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const handleCourseRestriction = async () => {
      setLoading(true);
      setError(null);

      try {
        const res: any = await courseApi.getCourseRestriction(courseId);

        setData(res?.content ?? null);

        if (res?.content?.course_restricted) {
          window.location.href = RoutesGenerator(
            Route.AdmissionInfoForm,
            {
              id: res?.content?.course_restriction_id,
              returnUrl: returnUrlOnSubmit,
              courseId,
            },
          );
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    handleCourseRestriction();
  }, [courseId]);

  return {
    data,
    locked: data?.course_restricted ?? false,
    loading,
    error,
  };
};

export default useCourseRestriction;
